import script from "./teamList.vue?vue&type=script&setup=true&lang=js"
export * from "./teamList.vue?vue&type=script&setup=true&lang=js"

import "./teamList.vue?vue&type=style&index=0&id=4cedecff&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cedecff"]])

export default __exports__